<template>
    <v-container fluid>
        <v-row>
            <v-container fluid>
                <v-card>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="4"> </v-col>
                            <v-col cols="12" sm="8" class="grey lighten-5" align="start" justify="center">
                                <v-row>
                                    <v-col cols="12"> <strong>ACTIONS</strong></v-col>

                                    <v-col cols="12" align="start" justify="center">
                                        <v-btn class="mx-1" small color="green" dark @click="downloadHandle">
                                            DESCARGAR <v-icon right dark> mdi-arrow-down-box </v-icon>
                                        </v-btn>

                                        <v-btn class="mx-1" small color="primary" dark @click="openForm(1)"> CREAR </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-row>
        <v-row>
            <v-col cols="12"
                ><v-card>
                    <v-card-title dark>
                        <strong>ESTADOS</strong>
                        <v-spacer />
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="BUSCAR" single-line hide-details />
                    </v-card-title>                    
                    <v-card-text
                        ><v-data-table
                            item-key="id"
                            flat
                            :headers="headers"
                            :items-per-page="20"
                            :items="lista"
                            :search="search"
                            :loading="loading"
                            :sort-by="['orden']"
                            :sort-desc="[true]"
                            loading-text="...Cargando"
                        >
                            <template v-slot:[`item.fechaCreacion`]="{ item }">
                                {{ item.fechaCreacion | fechaISO }}
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon color="green" @click="openForm(4, item)"> mdi-eye </v-icon>
                                <v-icon color="blue" @click="openForm(2, item)"> mdi-pencil </v-icon>
                                <v-icon color="red" @click="openForm(3, item)"> mdi-delete </v-icon>
                            </template>
                        </v-data-table></v-card-text
                    >
                </v-card></v-col
            >
        </v-row>
        <v-dialog v-model="openDialog" v-if="openDialog" persistent max-width="360px">
            <v-card>
                <v-card-title class="grey lighten-5">
                    <strong>{{ modalText }} ESTADOS</strong>
                </v-card-title>
                <v-container class="pa-3" align="center">
                    <v-row align="center">
                        <v-col cols="12">
                            <v-text-field
                                v-model="datos.descripcion"
                                v-validate="'required'"
                                dense
                                hide-details="auto"
                                outlined
                                label="Descripción*"
                                :error-messages="errors.collect('datos.descripcion')"
                                data-vv-name="datos.descripcion"
                                required
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="datos.orden"
                                v-validate="'required'"
                                dense
                                hide-details="auto"
                                outlined
                                label="Orden*"
                                :error-messages="errors.collect('datos.orden')"
                                data-vv-name="datos.orden"
                                @keypress="isNumber"
                                required
                            />
                        </v-col>
                        <v-col cols="12">
                            <small>*Campos Obligatorios</small>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions class="grey lighten-5">
                    <v-spacer />
                    <v-btn color="darken-1" text @click="EMPTY_FORM"> CERRAR </v-btn>
                    <v-btn v-if="step != 4" :loading="loadingBTN" color="primary" @click="fnHandleCrud"> {{ modalText }} </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Delete :open="openDelete" :loadingBTN="loadingBTN" @handle-delete="fnHandlePut" @closeModal="closeDocumento" />
    </v-container>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { exportXLSX } from '@/utils'
import { mixins } from '@/mixins/mixin.js'
import Delete from '@/components/modals/Delete'
import Documento from '@/components/modals/Documento'

const defaultText = 'REGISTRAR'

export default {
    components: {
        Delete,
        Documento
    },
    mixins: [mixins],

    data() {
        return {
            menu: false,
            fechaFiltro: new Date().toISOString().substr(0, 7),
            openDialog: false,
            openDelete: false,
            openDocumento: false,
            search: '',
            singleSelect: true,
            loadingBTN: false,
            selected: null,
            modalText: defaultText,
            step: 1,
            loading: false,
            headers: [
                { text: 'Actions', value: 'actions', sortable: false },
                { text: 'Descripción', value: 'descripcion' },
                { text: 'Orden', value: 'orden' }, 
                { text: 'Fecha Creación', value: 'fechaCreacion' }
            ]
        }
    },
    watch: {
        step(val) {
            if (val == 1) {
                this.modalText = defaultText
            } else if (val == 2) {
                this.modalText = 'ACTUALIZAR'
            } else if (val == 3) {
                this.modalText = 'ELIMINAR'
            } else {
                this.modalText = 'VISUALIZAR'
            }
        }
    },
    computed: {
        ...mapGetters('estados', ['lista']),
        ...mapState('estados', ['datos']),
        ...mapState('utilities', ['tipoDocumento'])
    },
    methods: {
        ...mapMutations({
            RESET_FORM: 'estados/RESET_FORM',
            UPDATE_DATOS: 'estados/UPDATE_DATOS',
            OPEN_MODAL: 'mainUI/OPEN_MODAL',
            OPEN_BAR: 'mainUI/OPEN_BAR'
        }),
        ...mapActions({
            handleGet: 'estados/obtenerLista',
            handlePost: 'estados/registrar',
            handlePut: 'estados/actualizar'
        }),
        EMPTY_FORM() {
            this.openDialog = false
            this.loading = false
            this.loadingBTN = false
            this.menu = false
            this.selected = null
            this.openDelete = false
            this.openDocumento = false
            this.OPEN_MODAL({ state: false })
            this.step = 1
            this.RESET_FORM()
        },
        openForm(tipo, item) {
            this.step = tipo
            let status = false
            this.selected = item
            if (tipo == 1) {
                this.RESET_FORM()
                status = true
            } else if (tipo == 2 || tipo == 4) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    status = true
                    this.UPDATE_DATOS(item)
                }
            } else if (tipo == 3) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    this.openDelete = true
                }
            }
            this.openDialog = status
        },
        async fnHandleCrud() {
            this.loadingBTN = true
            this.OPEN_MODAL({ state: true })
            if (this.step == 1) {
                await this.handlePost(this.datos)
            } else {
                const item = this.selected
                await this.handlePut(item)
            }
            await this.fnHandleGet({ status: true })
            this.EMPTY_FORM()
        },
        async fnHandlePut() {
            this.loadingBTN = true
            const item = this.selected
            if (this.step == 3) {
                item.activo = 0
            }
            await this.handlePut(item)
            await this.fnHandleGet({ status: true })
            this.EMPTY_FORM()
        },
        async fnHandleGet({ status = false }) {
            this.loading = true
            await this.handleGet({ fechaFiltro: this.fechaFiltro, status })
            this.EMPTY_FORM()
        },

        downloadHandle() {
            this.loading = true
            const headers = ['id', 'descripcion', 'orden', 'fechaCreacion']
            const filename = `REPORT_ESTADOS_${Date.now()}`
            exportXLSX({ headers, campos: headers, arrayData: this.lista }, { filename })
            this.loading = false
        },
        closeDocumento(nombreModal) {
            this[nombreModal] = false
        }
    },
    async created() {
        console.log('created1')
        await this.fnHandleGet({})
        console.log('created2')
    }
}
</script>
